import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdClose } from "react-icons/md";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import {
  headerRoutes,
  menuSocial,
  BIZFLEX_LOGIN_URL,
  BIZFLEX_REGISTER_URL,
} from "../common/constants";
import { Box, Button, Collapse, Flex, Image, Text } from "@chakra-ui/react";
import { Link as ScrollLink } from "react-scroll";
import { RiArrowDownSLine } from "react-icons/ri";
import { brandGradientButtonStyles } from "../../lib/brandGradient";

const Menu = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [expandedDropdown, setExpandedDropdown] = useState(null);

  const handleNavigation = (path) => {
    onClose();
    setExpandedDropdown(null);
    navigate(path);
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  const toggleDropdown = (id) => {
    setExpandedDropdown((current) => (current === id ? null : id));
  };

  const renderMobileNavItem = (data) => {
    if (data.hasDropdown && data.children?.length) {
      const isExpanded = expandedDropdown === data.id;

      return (
        <Box key={data.id}>
          <Flex
            px="20px"
            py="19px"
            borderBottom="1px solid #FFFFFF1A"
            color="#fff"
            lineHeight="27px"
            w="full"
            align="center"
            justify="space-between"
            cursor="pointer"
            onClick={() => toggleDropdown(data.id)}
          >
            <Text transition=".3s ease-in-out" _hover={{ color: "orange" }}>
              {data.name}
            </Text>
            <RiArrowDownSLine
              size="20px"
              style={{
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
            />
          </Flex>
          <Collapse in={isExpanded} animateOpacity>
            {data.children.map((child) => (
              <Flex
                key={child.name}
                px="24px"
                py="14px"
                gap="12px"
                borderBottom="1px solid #FFFFFF1A"
                cursor="pointer"
                transition=".3s ease-in-out"
                _hover={{ bg: "#FFFFFF0D" }}
                onClick={() => handleNavigation(child.path)}
              >
                <Flex
                  align="center"
                  justify="center"
                  w="36px"
                  h="36px"
                  borderRadius="full"
                  bg="#EEF4FF"
                  flexShrink={0}
                >
                  <Image
                    src={child.icon}
                    alt=""
                    w="18px"
                    h="18px"
                    objectFit="contain"
                  />
                </Flex>
                <Box>
                  <Text color="#fff" fontSize="14px" fontWeight={600} mb="2px">
                    {child.name}
                  </Text>
                  <Text color="#FFFFFFB3" fontSize="12px" lineHeight="1.4">
                    {child.description}
                  </Text>
                </Box>
              </Flex>
            ))}
          </Collapse>
        </Box>
      );
    }

    return (
      <Box
        px="20px"
        py="19px"
        borderBottom="1px solid #FFFFFF1A"
        color="#fff"
        lineHeight="27px"
        w="full"
      >
        {data.isExternal ? (
          <a
            href={data.path}
            target="_blank"
            rel="noreferrer"
            onClick={onClose}
          >
            <Text
              transition=".3s ease-in-out"
              cursor="pointer"
              _hover={{ color: "orange" }}
            >
              {data.name}
            </Text>
          </a>
        ) : data.path && data.path !== "/" ? (
          <Text
            onClick={() => handleNavigation(data.path)}
            cursor="pointer"
            transition=".3s ease-in-out"
            _hover={{ color: "orange" }}
          >
            {data.name}
          </Text>
        ) : (
          <ScrollLink
            to={data.id}
            smooth={true}
            duration={500}
            onClick={onClose}
            style={{ cursor: "pointer", textDecoration: "none" }}
          >
            <Text>{data.name}</Text>
          </ScrollLink>
        )}
      </Box>
    );
  };

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      direction="top"
      style={{
        height: "fit-content",
        width: "100%",
        background: pathname.includes("business") ? "#2463EB" : "#0F172B",
      }}
    >
      <Box h="3px" bg="linear-gradient(88deg, #FF9D16 0%, #2463EB 100%)" />

      <Flex
        px="16px"
        mt="15px"
        justifyContent="space-between"
        align="flex-start"
        w="full"
      >
        <Image src="/assets/header-logo.svg" w="96.67px" h="29px" />
        <MdClose onClick={onClose} size="20px" />
      </Flex>

      <Box mt="20px" px="15px">
        {headerRoutes.map((data) => renderMobileNavItem(data))}
      </Box>

      <Flex
        mt="20px"
        px="20px"
        pb="20px"
        direction="column"
        gap="12px"
        borderBottom="1px solid #FF9D16"
      >
        <a
          href={BIZFLEX_LOGIN_URL}
          target="_blank"
          rel="noreferrer"
          onClick={onClose}
          style={{ width: "100%" }}
        >
          <Button
            w="full"
            h="48px"
            bg="transparent"
            border="1px solid #FFFFFF66"
            borderRadius="12px"
            color="#fff"
            fontWeight={600}
            _hover={{ bg: "#FFFFFF14" }}
          >
            Log in
          </Button>
        </a>
        <a
          href={BIZFLEX_REGISTER_URL}
          target="_blank"
          rel="noreferrer"
          onClick={onClose}
          style={{ width: "100%" }}
        >
          <Button
            w="full"
            h="48px"
            borderRadius="8px"
            fontWeight={400}
            {...brandGradientButtonStyles}
          >
            Get Started
          </Button>
        </a>
      </Flex>

      <Flex
        mt="20px"
        pb="40px"
        justifyContent="center"
        align="center"
        gap="26px"
      >
        {menuSocial.map((item, i) => (
          <Flex
            key={i}
            border="1px solid #efefef"
            borderRadius="3px"
            justifyContent="center"
            align="center"
            w="40px"
            h="40px"
          >
            <a href={item.link} target="_blank" rel="noreferrer">
              <Image src={item.img} w="16px" h="16px" objectFit="contain" />
            </a>
          </Flex>
        ))}
      </Flex>
    </Drawer>
  );
};

export default Menu;
